<template>
  <div class="full-wrapper">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <el-row>
          <!-- <w-performance-service-analysis-chart :active="active" /> -->
          <w-performance-analysis-chart-view :active="active" :chart-datas="filteredPerfChartTypeData" :obj-list="objList" :prevent-check-chart-type-by-mgr="true"/>
        </el-row>
        <hr class="mr-b20" />
        <el-row>
          <w-performance-service-analysis-table />
        </el-row>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop" />
  </div>
</template>

<script>
import { isEmpty, forEach, includes } from 'lodash';
import { mapGetters } from 'vuex';
import { getPerfChartTypeParams } from '@/utils/performance';
import ChartAPI from '@/api/performance/analysis/analysis-chart';
import perfCommonApi from '@/api/performance/common';
import ScrollbarMixin from '@/mixins/scrollbar';
import WPerformanceAnalysisChartView from '@/views/performance/node/analysis/components/PerformanceAnalysisChartView';
// import WPerformanceServiceAnalysisChart from './PerformanceServiceAnalysisChart';
import WPerformanceServiceAnalysisTable from './PerformanceServiceAnalysisTable';
import perfChartType from './perf-chart-type';

export default {
  name: 'WPerformanceServiceAnaylsis',
  mixins: [ScrollbarMixin],
  components: {
    // WPerformanceServiceAnalysisChart,
    WPerformanceAnalysisChartView,
    WPerformanceServiceAnalysisTable,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      perfChartType,
      objList: [],
      filteredPerfChartTypeData: [],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    /**
     * 다른 서비스 선택 시 해당 서비스에 포함된 관리대상을 다시 가져온다.
     * @type {Object}
     */
    selectedNode: {
      immediate: true,
      handler(node) {
        if (node.subType !== 'service' || isEmpty(node) || !this.active) {
          return;
        }
        this.loadObjDatasOfService();
      },
    },
    active: {
      handler(value) {
        if (!value || isEmpty(this.selectedNode) || this.selectedNode.subType !== 'service') {
          return;
        }
        this.loadObjDatasOfService();
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    /**
     * 서비스에 구성된 장비 정보를 로드한다.
     * @author Ju
     */
    loadObjDatasOfService() {
      ChartAPI.getObjsByService({
        serviceId: this.selectedNode.obj.objId,
      }).then((response) => {
        if (response.data.success) {
          const objList = response.data.data;
          // 서비스에 구성된  장비 정보 처리
          const elementTypes = [];
          forEach(objList, (obj) => {
            if (obj.elementType === 'WIRELESS_DEVICE') {
              obj.elementType = 'NETDEVICE';
            }
            if (!includes(elementTypes, obj.elementType)) {
              elementTypes.push(obj.elementType);
            }
            if (obj.elementType === 'E2E_SERVICE') {
              obj.objId = obj.agentIds;
            }
          });
          // 서비스에 구성된 elementType 기준으로 차트 정보 처리
          const filteredPerfChartType = {};
          elementTypes.forEach((elementType) => {
            const type = elementType === 'E2E_SERVICE' ? 'E2E' : elementType;
            if (!isEmpty(this.perfChartType[type])) {
              filteredPerfChartType[type] = this.perfChartType[type];
            }
          });
          this.objList = objList;
          this.loadPerfChartTypeByMgr(filteredPerfChartType);
        }
      });
    },
    loadPerfChartTypeByMgr(perfChartDatas) {
      perfCommonApi.getPerfChartTypeByMgr(getPerfChartTypeParams(this.selectedNode.obj)).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          const filteredPerfChartTypeData = [];
          result.forEach((record) => {
            if (!isEmpty(perfChartDatas[record.chartTypeId])) {
              filteredPerfChartTypeData.push(perfChartDatas[record.chartTypeId]);
            }
          });
          this.filteredPerfChartTypeData = filteredPerfChartTypeData;
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/service/index.vue